export const PAGES = {
  ADMIN: '/dashboard/admin',
  COMPANIES: '/dashboard/companies',
  HOME: '/dashboard/home',
  INVESTORS: '/dashboard/investors',
  LOGIN: '/login',
  NEWS: '/dashboard/news',
  PROFILE: '/dashboard/profile',
} as const;
